import { getValueFromScope } from '@edicom/common/parser/getValueFromScope';
import { setValueToScope } from '@edicom/common/parser/setValueToScope';

export default function ecNgModelService() {
  return {
    isNewField: (scope, model) => typeof getValueFromScope(scope, model, { isImmutable: false }) === 'undefined',
    setViewValue,
    getViewValue,
    setModelValue: (scope, model, value) => setValueToScope(scope, model, value, { isImmutable: false }),
    getModelValue: (scope, model) => getValueFromScope(scope, model, { isImmutable: false }),
  };
}

/*
ejemplo:
  isNewField(scope, ngModelController.$name)
  isNewField(scope, 'CAB.NUMFAC')
  @param object scope
  @param string model
  @return boolean
*/
// function isNewField(scope, model){
//   // equivalente a : scope.$eval(model) === undefined ???
//   const properties = model.split('.');
//   for(let i=0, len=properties.length, cur=scope; i<len; i++){
//     cur = cur[properties[i]];
//     if(cur === undefined){ return true; }
//   }
//   return false;
// }

/*
  ejemplo de uso con creación de función:
  const setViewValue = ecNgModelService.setViewValue.bind(null, ngModelController);
  setViewValue('mi value')
*/
function setViewValue(ngModelController, value) {
  ngModelController.$setViewValue(value);
  ngModelController.$render();
}

function getViewValue(ngModelController) {
  return ngModelController.$viewValue || '';
}

// function setModelValue(scope, model, value){
//   let m = model.split('.'),
//   len = m.length;
//   m.reduce((pre, cur) => {
//     if(!--len){
//       pre[cur] = value;
//       return;
//     }
//     if(!pre[cur]){ pre[cur] = {}; }
//     return pre[cur];
//   }, scope);
// }
//
// function getModelValue(scope, model){
//   return model.split('.').reduce((acc, cur) => {
//     if(!acc[cur]) { acc[cur] = {}; }
//     return acc[cur];
//   }, scope);
// }
